'use es6';

import { Children, isValidElement, createContext as createContext$1, useContext } from 'react';
import { isFunction } from "../utils";

// src/children.ts
function getValidChildren(children) {
  return Children.toArray(children).filter(child => /*#__PURE__*/isValidElement(child));
}

// src/context.ts
function createContext(options = {}) {
  const {
    strict = true,
    errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name
  } = options;
  const Context = /*#__PURE__*/createContext$1(void 0);
  Context.displayName = name;
  function useContext$1() {
    var _a;
    const context = useContext(Context);
    if (!context && strict) {
      const error = new Error(errorMessage);
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext$1);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext$1, Context];
}

// src/refs.ts
function assignRef(ref, value) {
  if (ref == null) return;
  if (isFunction(ref)) {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return node => {
    refs.forEach(ref => assignRef(ref, node));
  };
}
export { assignRef, createContext, getValidChildren, mergeRefs };